import NextLinkButton from './NextLinkButton'

export default NextLinkButton
